import './machine_app_debugger.css';
import $ from 'jquery';
import { modal } from './components/machine_app_modal';
import { showMessageBox } from './components/machine_app_toast_message_box';
const ml_widgets = require('../legacy/widgets');
const machine_app_state = require('./models/machine_app_state');
const machine_app_dev_reload_button = require('./machine_app_dev_reload_button');
const machine_app_implementation_loader = require('./models/machine_app_implementation_loader');
import React from 'react';
import * as ReactDOM from 'react-dom';
import { AppEnablerView, FlagsView } from './debugger';

enum DebugViews {
  JsonEditor,
  InterfaceTester,
  AppEnabler,
  Flags,
  AdminView
}

interface ViewReturnValue {
  cleanup: () => void;
}

export function developerTools(pOnSave, pMachineAppType) {
  const lModal = modal();
  const lHeader = $('<div>').addClass('machine_app_debugger_header');
  const lBody = $('<div>').addClass('machine_app_debugger_body');
  const lFooter = $('<div>').addClass('machine_app_debugger_footer');
  lModal.content.css('padding', '24px').append(lHeader, lBody, lFooter);

  let lLastView: ViewReturnValue | undefined = undefined;
  const lRender = function(pView) {
    if (lLastView?.cleanup) lLastView.cleanup();
    lLastView = undefined;
    const bodyDiv = lBody.get(0);
    if (bodyDiv) {
      ReactDOM.unmountComponentAtNode(bodyDiv);
    }
    lBody.empty();
    lFooter.empty();
    lHeader.find('.selected').removeClass('selected');
    lHeader.children().eq(pView).addClass('selected');
    switch (pView) {
      case DebugViews.JsonEditor: {
        lLastView = jsonEditor(lBody, lFooter, pOnSave);
        break;
      }
      case DebugViews.InterfaceTester: {
        interfaceTester(lBody, lModal);
        break;
      }
      case DebugViews.AdminView: {
        lAdminViewer({ container: lBody, machineAppInterface: machine_app_state.getInterface() });
        break;
      }
      case DebugViews.AppEnabler: {
        if (bodyDiv) {
          ReactDOM.render(<AppEnablerView />, bodyDiv);
        }
        break;
      }
      case DebugViews.Flags: {
        if (bodyDiv) {
          ReactDOM.render(<FlagsView />, bodyDiv);
        }
        break;
      }
      default:
        console.error('Unknown debug view: ' + pView);
        break;
    }
  };

  const lAdminViewer = machine_app_implementation_loader.instance.getAdminView(pMachineAppType);
  const getUpdateViewFunc = (pView) => () => lRender(pView);
  const lJsonEditorBtn = $('<button>').addClass('machine_app_debugger_header_button').text('Json Editor').on('click', getUpdateViewFunc(DebugViews.JsonEditor));
  const lInterfaceBtn = $('<button>').addClass('machine_app_debugger_header_button').text('Interface Tester').on('click', getUpdateViewFunc(DebugViews.InterfaceTester));
  let lAdminBtn;
  if (lAdminViewer) {
    lAdminBtn = $('<button>').addClass('machine_app_debugger_header_button').text('Admin View').on('click', getUpdateViewFunc(DebugViews.AdminView));
  }
  const lAppEnabler = $('<button>').addClass('machine_app_debugger_header_button').text('App Enabler').on('click', getUpdateViewFunc(DebugViews.AppEnabler));
  const lFlagView = $('<button>').addClass('machine_app_debugger_header_button').text('Flags').on('click', getUpdateViewFunc(DebugViews.Flags));
  const lExitButton = $('<button>').addClass('far machine_app_modal_close').on('click', () => lModal.hide());
  lHeader.append(lJsonEditorBtn, lInterfaceBtn, lAppEnabler, lFlagView, lAdminBtn, localBundleToggle(), lExitButton);

  lModal.show();
  lRender(DebugViews.JsonEditor);
}

function localBundleToggle() {
  const lContainer = $('<div>').addClass('machine-app-use-local-bundle');
  const lCheckBox = $('<input>')
    .attr('type', 'checkbox')
    .prop('checked', localStorage.getItem('machine_app_local_bundle') != null)
    .on('change', function() {
      const isChecked = lCheckBox.prop('checked') === true;
      if (isChecked) {
        localStorage.setItem('machine_app_local_bundle', '');
      }
      else {
        localStorage.removeItem('machine_app_local_bundle');
      }
      machine_app_implementation_loader.instance.loadLibrary();
      machine_app_dev_reload_button.refresh();
    });
  const lLabel = $('<label>').text('Use Local Bundle?');

  lContainer.append(lCheckBox, lLabel);

  return lContainer;
}

function jsonEditor(lBody, lFooter, pOnSave) {
  const lAceEditorContainer = $('<div>').css({ width: '100%', height: '100%'}).attr('id', 'machine_app_ace_editor_body').appendTo(lBody);
  const editor = getMachineAppsJsonEditor(lAceEditorContainer.attr('id'));

  lFooter.append(
    $('<button>').text('Save').on('click', function() {
      try {
        const lJson = JSON.parse(editor.getValue());
        machine_app_state.getLibraryManager().fromJson(lJson, false);
        machine_app_state.getLibraryManager().saveAll(function(pSuccess) {
          if (pSuccess) {
            showMessageBox('Saved', 'success');
            pOnSave();
          }
          else {
            showMessageBox('Failed to save', 'error');
          }
        });
      }
      catch (e) {
        showMessageBox('Invlaid json format', 'error');
      }
    }).addClass('machine_app_debugger_footer_button machine_app_debugger_footer_button_success'),
    $('<button>').text('Reset All').on('click', function() {
      if (window.confirm('Are you sure that you want to erase all MachineApps data?')) {
        const lJson = machine_app_state.getLibraryManager().toJson();
        lJson.libraryList = [];
        machine_app_state.getLibraryManager().fromJson(lJson, false);
        machine_app_state.getLibraryManager().saveAll(function(pSuccess) {
          if (pSuccess) {
            showMessageBox('Saved', 'success');
            pOnSave();
          }
          else {
            showMessageBox('Failed to save', 'error');
          }
        });
      }
    }).addClass('machine_app_debugger_footer_button machine_app_debugger_footer_button_error')
  );

  return {
    cleanup: () => editor.destroy()
  };
}

function getMachineAppsJsonEditor(pId) {
  const editor = ml_widgets.aceEditor(
    pId,
    JSON.stringify(machine_app_state.getLibraryManager().toJson(), null, 2),
    'ace/mode/json'
  );
  editor.getSession().setTabSize(2);
  editor.getSession().setUseWrapMode(true);
  editor.setTheme("ace/theme/monokai");
  editor.getSession().setMode("ace/mode/json");
  return editor;
}

function interfaceTester(pBody, pModal) {
  const lInterface = machine_app_state.getInterface();
  const lContainer = $('<div>').addClass('machine_app_interface_debugger');

  //Part Selection Variables
  const lPartSelectionSection = $('<div>').addClass('machine_app_interface_debugger_section');
  const lPartSelectionStartButton = $('<button>')
    .text('Start Part Selection')
    .on('click', function() {
      lInterface.startPartSelection(lStartSelectionCallBack);
      pModal.hide();
    })
    .addClass('machine_app_interface_debugger_section_button');
  const lStartSelectionCallBack = (pSelectedPartVid) => {
    console.debug("User has selected part with VID: ", pSelectedPartVid);
  };
  const lSetPartSelectionStartButtonState = () => {
    lPartSelectionStartButton.removeClass('selected');
    if(lInterface._getManipulatorType() == 'manip-machineapp-part-selector'){
      lPartSelectionStartButton.addClass('selected');
    }
  };

  //Orient Body Varia(b)ls
  const lOrientBodySection = $('<div>').addClass('machine_app_interface_debugger_section');
  const lVidInputElementOrientBody = $('<input>').addClass('machine_app_interface_debugger_vid_input');
  const lOrientBodyOnClick = () => {
    const lInputtedVID = parseInt(lVidInputElementOrientBody.val() as string);
    if(!lInputtedVID){
      window.alert('You must paste or write down a VID in the provided input');
      return;
    }
    lInterface.startOrientingBody(lInputtedVID);
    pModal.hide();
  };

  //Part Inserter Variables
  const lPartInserterSection = $('<div>').addClass('machine_app_interface_debugger_section');

  //Bounding Box Variables
  const lBoundBoxSection = $('<div>').addClass('machine_app_interface_debugger_section');
  const lVidInputElementBoundingBox = $('<input>').addClass('machine_app_interface_debugger_vid_input');
  const lBoundBoxCallback = (pBoundingBox, pVid) => {
    console.debug(`Bounding Box of vid ${pVid}:`, pBoundingBox);
  };
  const lBoundBoxOnClick = () => {
    const lInputtedVIDBB = parseInt(lVidInputElementBoundingBox.val() as string);
    if(!lInputtedVIDBB){
      window.alert('You must paste or write down a VID in the provided input');
      return;
    }
    lInterface.getBoundingBox(lInputtedVIDBB, lBoundBoxCallback);
  };

  //APPEND BELOW
  lPartSelectionSection.append(
    $('<h3>').text('Part Selection'),
    $('<div>').addClass('machine_app_interface_debugger_section_content').append(
      lPartSelectionStartButton,
      $('<button>').text('Stop Part Selection').on('click', function() {
        lInterface.stopPartSelection();
        lSetPartSelectionStartButtonState();
      }).addClass('machine_app_interface_debugger_section_button')
    )
  );

  lOrientBodySection.append(
    $('<h3>').text('Orient Body'),
    $('<div>').addClass('machine_app_interface_debugger_section_content').append(
      $('<button>').text('Start Orienting Body').on('click', lOrientBodyOnClick)
        .addClass('machine_app_interface_debugger_section_button'),
      $('<span>').text('VID:').css({margin: 'auto 0'}),
      lVidInputElementOrientBody
    )
  );

  lPartInserterSection.append(
    $('<h3>').text('Part Insertion'),
    $('<div>').addClass('machine_app_interface_debugger_section_content').append(
      $('<button>').text('Insert Estop Module @ (1000,1000,1000)').on('click', function() {
        lInterface.insertPart(
          "CE-SA-007-0000", // Reset module for testing
          function(pVid) { console.debug("Inserted part has VID: ", pVid); },
          function() { console.debug("Part insertion is cancelled"); },
          {
            position: { x: 1000, y: 1000, z: 1000 },
            viewOrientation: 0
          }
        );
      }).addClass('machine_app_interface_debugger_section_button')
    )
  );

  lBoundBoxSection.append(
    $('<h3>').text('Get Bounding Box'),
    $('<div>').addClass('machine_app_interface_debugger_section_content').append(
      $('<button>').text('Get Bounding Box').on('click', lBoundBoxOnClick)
        .addClass('machine_app_interface_debugger_section_button'),
      $('<span>').text('VID:').css({margin: 'auto 0'}),
      lVidInputElementBoundingBox
    )
  );

  lSetPartSelectionStartButtonState();

  lContainer.append(
    lPartSelectionSection,
    lOrientBodySection,
    lPartInserterSection,
    lBoundBoxSection
  );

  pBody.append(lContainer);
}